import {useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress, Typography } from '@mui/material';
import classes from './BaseEmployersScreen.module.css';
import { useEmployers } from 'modules/employers/services/employers.service';
import { Employer } from 'modules/employers/services/employer';
import { Action, DataTable } from 'modules/shared/components/DataTable/DataTable';
import { HeadCell } from 'modules/shared/components/DataTable/interfaces';


export interface GridRow {
  raw: Employer;
  name: string;
  jobsCount: string;
  location: string;
}


const headCells: readonly HeadCell<GridRow, keyof GridRow>[] = [
  {
    id: 'name',
    numeric: false,
    label: 'Employer',
    sortable: true,
    sortValue: row => row.raw.billingState
  },
  {
    id: 'jobsCount',
    numeric: true,
    label: 'Jobs',
    sortable: true,
  },
  {
    id: 'location',
    numeric: false,
    label: 'Location',
    sortable: true,
  }
];


type Props = {
  actions?: Action<GridRow>[]; // actions are shown in table row 3 dots menu
  employers: Employer[];
  setEmployers: (val: Employer[]) => void;
};


export function BaseEmployersScreen({ actions, employers, setEmployers }: Props) {
  const { getEmployers } = useEmployers();
  const navigate = useNavigate();
  const [rows, setRows] = useState<GridRow[]>([]);

  useEffect(() => {
    getEmployers().then(setEmployers);
  }, [getEmployers]);

  // fill rows for the table
  useEffect(() => {
    employers && setRows(employers.map(employer => {
      return {
        raw: employer,
        name: employer.companyName,
        jobsCount: employer.jobsCount ? ('' + employer.jobsCount) : '0',
        location: employer.billingCity + ', ' + employer.billingState,
      };
    }));
  }, [employers]);

  function handleClick({ raw }: GridRow) {
    navigate('employers/' + raw.ref.id + '/jobs');
  }

  return(
      <div className={classes.container}>

        <div className={classes.header}>
          <Typography variant='h4' sx={{color: 'mainBackground.contrastText'}}>Employers</Typography>
          { !employers && <CircularProgress className={classes.progress} size={30}/> }
        </div>

        <DataTable
          data={rows}
          headCells={headCells}
          initialOrderBy='name'
          keyField={row => row.name || row.raw.hrEmail}
          onRowClick={handleClick}
          minWidth={400}
          actions={actions}
        />
      </div>
  )
}
